import { type FC } from 'react';
import { Col } from 'react-bootstrap';
import DelayedDroppableWrapper from '@editor2/components/DelayedDroppableWrapper';

import TableOfContentsChapter from './TocChapter';
import { columnContainer } from '@editor2/containers/TableOfContentsPage/styles';

interface Props {
	chapterIds: string[];
	courseId: number;
	columnIndex: number;
	groupSize: number;
}

const TableOfContentsColumn: FC<Props> = (props) => {
	const { chapterIds, columnIndex, groupSize, courseId } = props;

	return (
		<DelayedDroppableWrapper droppableId={`${columnIndex}`} type="Chapter">
			{(provided) => (
				<Col className={columnContainer} ref={provided.innerRef} {...provided.droppableProps}>
					{chapterIds.map((chapterId, index) => (
						<TableOfContentsChapter
							chapterId={chapterId}
							courseId={courseId}
							index={columnIndex * groupSize + index}
							key={chapterId}
						/>
					))}
					{provided.placeholder}
				</Col>
			)}
		</DelayedDroppableWrapper>
	);
};

export default TableOfContentsColumn;
